// Branch name generation (client-side preview, mirrors server's issueKeyParser.ts)

export function generateBranchName(
  pattern: string,
  issue: { issueKey: string; title: string; issueType: string; projectKey: string },
): string {
  const slug = toKebabCase(issue.title, 50);
  return pattern
    .replace(/\{type\}/g, issue.issueType.toLowerCase())
    .replace(/\{issueKey\}/g, issue.issueKey)
    .replace(/\{slug\}/g, slug)
    .replace(/\{projectKey\}/g, issue.projectKey);
}

function toKebabCase(text: string, maxLength: number): string {
  const kebab = text
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s-]/gu, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  if (kebab.length <= maxLength) return kebab;
  const truncated = kebab.slice(0, maxLength);
  const lastHyphen = truncated.lastIndexOf('-');
  return lastHyphen > 0 ? truncated.slice(0, lastHyphen) : truncated;
}
